export const shrinkTextBased = (limit = 0, text = '') => {
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
};

export const getFirstLetters = (str: string = ''): string => {
  if (!str) return ''; // Handle empty string or undefined

  const words = str.split(' ');
  let firstLetters;

  if (words.length === 1) {
    firstLetters = words.map((word) => word.slice(0, 1));
  } else {
    firstLetters = words.slice(0, 2).map((word) => word.slice(0, 1));
  }

  return firstLetters.join('').toUpperCase();
};
